import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propChildren, propOneOf, } from '../../../helpers/custom-prop-types';
const ToastBody = (props) => {
    const { className, content, type } = props;
    const { component, icon } = (() => {
        switch (type) {
            case 'info': {
                return {
                    component: content,
                    icon: 'check',
                };
            }
            case 'error': {
                return {
                    component: content || (_jsxs(_Fragment, { children: [_jsx("span", { children: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002" }), _jsx("br", {}), _jsx("span", { children: "\u3057\u3070\u3089\u304F\u6642\u9593\u3092\u7F6E\u3044\u3066\u304B\u3089\u3084\u308A\u76F4\u3059\u304B\u3001\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002" })] })),
                    icon: 'error',
                };
            }
            default: {
                return {
                    component: content,
                    icon: '',
                };
            }
        }
    })();
    return (_jsxs("div", Object.assign({ className: clsx('message_body', className) }, { children: [icon && _jsx("i", Object.assign({ className: 'material-icons message_icon' }, { children: icon })), _jsx("div", Object.assign({ className: 'message_main' }, { children: component }))] })));
};
ToastBody.propTypes = {
    className: propStr(),
    content: propChildren(),
    type: propOneOf(['info', 'error', 'default']),
};
ToastBody.defaultProps = {
    className: '',
    content: '',
    type: 'info',
};
export default ToastBody;
